import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getRequestByAuth,
  postRequestByAuth,
} from "../../../../function/helper";
import useSharedData from "../../../../hooks/useSharedData";

function IncreaseCredit() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useSharedData();

  const [help, setHelp] = useState(false);
  const [currentCredit, setCurrentCredit] = useState(0);
  const [priceIncreaseCredit, setPriceIncreaseCredit] = useState("");
  const [errorIncreaseCredit, setErrorIncreaseCredit] = useState();
  const [loading, setLoading] = useState(false);
  const setFormIncreaseCredit = value => {
    setPriceIncreaseCredit(value);
    if (errorIncreaseCredit) setErrorIncreaseCredit(null);
  };

  const sendIncreaseRequest = async () => {
    const response = await postRequestByAuth("/wallet/v1/gateway/request", {
      userId: user.id,
      amount: priceIncreaseCredit,
    });

    if (response.status === 200) {
      window.location.href = response.data.path;
      return;
    }

    Swal.fire({
      icon: "error",
      text: response.message,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "red",
      customClass: "rtl-all",
    }).then(() => setLoading(false));
  };

  const handleChargeWallet = async e => {
    e.preventDefault();
    if (!priceIncreaseCredit) {
      Swal.fire({
        icon: "error",
        text: "مبلغ مشخص نشده است",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    if (priceIncreaseCredit < 500000) {
      Swal.fire({
        icon: "error",
        text: "مبلغ نمی تواند از کمتر از 500 هزار ريال باشد",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    setLoading(true);
    await sendIncreaseRequest();
  };

  const getAmountWallet = async () => {
    const response = await getRequestByAuth(
      `/wallet/v1/all?numberpage=1&numberitems=1`
    );

    if (response && response.status === 200) {
      setCurrentCredit(response.data.amont);
      setHelp(!help);
    }
  };

  useEffect(() => {
    getAmountWallet();

    if (searchParams.get("increase") === "success") {
      Swal.fire({
        icon: "success",
        title: "افزایش اعتبار با موفقیت انجام شد",
        confirmButtonColor: "green",
        confirmButtonText: "متوجه شدم",
      });

      setSearchParams(cur => {
        cur.delete("increase");
        return cur;
      });
    }
  }, []);

  return (
    <Card style={{ fontFamily: "iran" }} className="p-3">
      <h4 className="text-secondary mt-3">افزایش اعتبار</h4>
      <hr className="" height="4" color="info" />
      <div className="p-3 m-1">
        <Form onSubmit={handleChargeWallet}>
          <Form.Group>
            <Form.Label> انتخاب مبلغ:</Form.Label>
            <Form.Select
              type="text"
              name="priceIncreaseCredit"
              value={priceIncreaseCredit}
              lg={6}
              md={6}
              sm={12}
              onChange={e => {
                setPriceIncreaseCredit(e.target.value);
                setHelp(!help);
              }}
            >
              <option></option>
              <option value="500000">500.000 ريال</option>
              <option value="1000000">1.000.000 ريال</option>
              <option value="1500000">1.500.000 ريال</option>
              <option value="2000000">2.000.000 ريال</option>
              <option value="2500000">2.500.000 ريال</option>
            </Form.Select>
            <Form.Label> مبلغ دلخواه(ريال):</Form.Label>

            <>
              <NumericFormat
                className="form-control"
                value={priceIncreaseCredit}
                name="rialValue"
                thousandSeparator=","
                suffix=" ریال"
                onValueChange={values => {
                  const { value } = values;
                  setFormIncreaseCredit(value);
                  setHelp(!help);
                }}
              />
            </>

            <Form.Control.Feedback type="invalid">
              {errorIncreaseCredit}
            </Form.Control.Feedback>
            <div className="mt-5 d-flex flex-wrap flex-wrap justify-content-center align-items-center">
              <span>اعتبار فعلی:</span>
              <span
                className={
                  "fs-4 fw-bold ltr mx-1 " +
                  (currentCredit >= 0 ? "text-success" : "text-danger")
                }
              >
                {currentCredit.toLocaleString()}
              </span>
              <small>ریال</small>
            </div>

            <hr />
          </Form.Group>
          <div className="d-flex align-items-center justify-content-center">
            {loading ? (
              <button className="btn-success-style my-2 px-5">
                <span
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            ) : (
              <button
                type="submit"
                className="btn-success-style text-center my-2 px-5"
              >
                پرداخت
              </button>
            )}
          </div>
        </Form>
      </div>
    </Card>
  );
}

export default IncreaseCredit;
